import { api } from '@/shared/helpers/axios.ts';

const PERSON_SETTINGS = '/person_settings';

export const settingsApi = {
	getPersonSettingsById: (id: string) =>
		api.get(`${PERSON_SETTINGS}/by_person/${id}`).then((res) => res.data),
	createPersonSettings: ({ personId, payload }: { personId: number; payload: any }) =>
		api
			.post(`${PERSON_SETTINGS}`, { person_id: personId, settings: payload })
			.then((res) => res.data),
	updatePersonSettingsById: ({ settingsId, payload }: { settingsId: string; payload: any }) =>
		api.patch(`${PERSON_SETTINGS}/${settingsId}`, payload),
	deletePersonSettingsById: (id: string) => api.delete(`${PERSON_SETTINGS}/${id}`),
};
